module.exports = __webpack_public_path__ + "img/thumb_16.40890fc5.jpg";